<template>
  <b-modal
    ref="modal"
    header-class="d-none"
    footer-class="d-none"
    body-bg-variant="secondary"
    :centered="true"
    :scrollable="false"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :title-html="data.title"
    @hide="hide"
    @hidden="onClose"
    @shown="onShow"
    @ok="close(1)"
  >
    <h5
      class="text-center text-white"
      v-html="data.body"
    ></h5>
    <switch-page-loader></switch-page-loader>
  </b-modal>
</template>

<script>
    import dmodalLoader from "@dialogs/modalLoader";
    import SwitchPageLoader from "@custom/comp/switchPageLoader";

    export default {
        mixins: [dmodalLoader],
        components: {SwitchPageLoader}
    };
</script>
<style lang="scss" scoped>
  .wrapper {
    z-index: 1;
    position: relative;
    width: 100%;
    height: 3px;
    left: 0;
    right: 0;
    bottom: -3px;
    top: 0
  }

</style>



// WEBPACK FOOTER //
// src/custom/mepsaws/dialogs/modalLoader.vue